import { defineManifest } from '@ndrc/app-sdk/manifest';
export const manifest = defineManifest({
  id: 'inbox',
  name: 'Inbox',
  description: 'Messagerie pédagogique de l’entreprise fictive.',
  icon: 'mail',
  color: 'blue',
  glyph: [{ d: 'M4 6h16v12H4z' }, { d: 'm4 6 8 7 8-7' }],
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'relation-client',
  permissions: {
    uses: [
      'files.read',
      'threads.read',
      'threads.write',
      'messages.read',
      'messages.write',
      'contacts.read',
      'interactions.write',
    ],
    defines: [],
  },
  entities: {
    uses: [
      { entity: 'threads' },
      { entity: 'messages' },
      { entity: 'contacts' },
      { entity: 'interactions', extends: { channel: ['email'] } },
    ],
    owns: [],
  },
  events: { emits: [], subscribes: [] },
  ui: {
    student: { defaultRoute: '/', routes: [{ path: '/', title: 'Conversations' }], layout: 'full' },
  },
  migrations: { schema: 'app_inbox', dir: 'migrations' },
});
